import React, { useState } from "react";
import classNames from "classnames";

import CloseIcon from "components/Icons/minus.svg";
import OpenIcon from "components/Icons/plus.svg";

type ExpandingSectionWithCountProps = {
  title: string;
  subtitle?: string;
  itemsSelected: number;
  children: JSX.Element | JSX.Element[];
  defaultOpen?: boolean;
  shouldExpandContainer?: boolean;
  className?: string;
};

const ExpandingSectionWithCount = ({
  title,
  subtitle,
  itemsSelected = 0,
  children,
  defaultOpen = false,
  shouldExpandContainer = false,
  className = "",
}: ExpandingSectionWithCountProps): JSX.Element => {
  const [open, setOpen] = useState(defaultOpen);
  const [sectionExpanded, setSectionExpanded] = useState(false);

  return (
    <div
      className={classNames(className, "border-t border-b border-light-grey")}
      style={{ marginTop: "-1px" }}
    >
      <button
        type="button"
        onClick={() => {
          setOpen(!open);
        }}
        className="flex justify-between text-left items-center w-full py-lg"
      >
        <span className="md:flex items-baseline">
          <h2 className="font-bold text-md">{title}</h2>
          {subtitle && (
            <p className="md:ml-sm text-grey mb-none text-xs">{subtitle}</p>
          )}
        </span>

        <div className="flex items-center">
          {!!itemsSelected && (
            <span
              className="flex justify-center items-center bg-light-grey rounded-full block text-xs font-bold mr-xs"
              style={{ height: 26, width: 26 }}
            >
              <span>{itemsSelected}</span>
            </span>
          )}
          <span>
            {open ? (
              <CloseIcon height="24" width="24" />
            ) : (
              <OpenIcon height="24" width="24" />
            )}
          </span>
        </div>
      </button>
      <div
        className="overflow-hidden"
        style={{ height: open ? "auto" : 0 }}
        data-testid="expanding-section-content"
      >
        <div
          style={
            shouldExpandContainer
              ? {
                  maxHeight: sectionExpanded ? "100%" : 250,
                }
              : {}
          }
          className="overflow-hidden"
          data-testid="expanding-section-expand-content"
        >
          {children}
        </div>
        {shouldExpandContainer && (
          <button
            type="button"
            onClick={() => setSectionExpanded(!sectionExpanded)}
            className="block text-xs text-green font-bold mb-xl"
            data-testid="expanding-section-expand-button"
          >
            {sectionExpanded ? "collapse all" : "expand all"}
          </button>
        )}
      </div>
    </div>
  );
};

export default ExpandingSectionWithCount;
